import tippy from "tippy.js";
import jquery from "jquery";

const $ = jquery;

$(".js-payment-label").each((i, el) => {
    tippy(el, {
        arrow: true,
        placement: "top", // top, right, bottom, left
        maxWidth: 253, // px or string
        allowHTML: true,
        hideOnClick: true,
        theme: "light",
        appendTo: () => document.body,
        trigger: "mouseenter",
        content: el.querySelector(".js-payment-type-tooltip"),
    });
});

if (!window.mobileMedia) {
    const paymentLabelsWrap = document.querySelector(".js-payment-labels");

    if (paymentLabelsWrap) {
        if (Array.from(paymentLabelsWrap.children).length > 3) {
            paymentLabelsWrap.style.removeProperty("gap");
            paymentLabelsWrap.style.justifyContent = "space-between";
        } else {
            paymentLabelsWrap.style.removeProperty("justifyContent");
            paymentLabelsWrap.style.gap = "11px";
        }
    }
}
